module.exports = __webpack_public_path__ + "static/media/TMDBLogo.12d095ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/MainFooter/images/TMDBLogo.svg
// module id = 172
// module chunks = 0